import React from "react";
import {
    TextField,
    SelectField,
    ArrayField,
    DateField,
    Datagrid
} from 'react-admin';
import specialities from "../helper/Speciality";

class SpecialitiesArrayField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayField {...this.props}>
                <Datagrid>
                    <SelectField label="Спеціалізація" source="speciality" choices={specialities} />
                    <SelectField label="Рівень кваліфікації" source="level" choices={[
                        { id: 'NOT_APPLICABLE', name: 'Не застосовується' },
                        { id: 'SECOND', name: 'Друга категорія' },
                        { id: 'FIRST', name: 'Перша категорія' },
                        { id: 'HIGHEST', name: 'Вища категорія' }
                    ]} />
                    <SelectField label="Тип кваліфікації" source="qualificationType"
                                 choices={[
                                     {id: 'AWARDING', name: 'Присвоєння'},
                                     {id: 'DEFENSE', name: 'Підтвердження'}
                                 ]}
                    />
                    <TextField label="Орган, що видав" source="attestationName" />
                    <DateField label="Дата отримання" source="attestationDate" />
                    <DateField label="Дата дії до" source="validToDate" />
                    <TextField label="Номер сертифікату" source="certificateNumber" />
                </Datagrid>
            </ArrayField>
        );
    }
}

export default SpecialitiesArrayField;
